<script>
import { groupBy } from "lodash";
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default: () => []
        },
        busy: {
            type: Boolean,
            default: false
        },
        forApproval: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            perPage: 10,
            currentPage: 1,
            pageOptions: [10, 25, 50, 100],
            filter: '',
            fields: [
                {
                    key: "name",
                    sortable: true,
                    label: "API Name",
                },
                {
                    key: "totalAmt",
                    sortable: true,
                    label: "Total Amount",
                    thStyle: { width: "180px" },
                },
                // {
                //     key: "score",
                //     sortable: true,
                //     label: "Score",
                //     thStyle: { width: "180px" },
                // },
                {
                    key: "action",
                    sortable: true,
                    thStyle: { width: "220px" },
                },
            ],
            sortBy: "id",
            filterOn: [],
            filterOnApp: [],
            sortDesc: true,
            selectedDU: null,
            selectedTargets: [],
            searchTargetApi: '',
        }
    },
    computed: {
        filtered(){
            let data = this.data;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterItem
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows() {
            if (this.filter) {
                return this.totalRows;
            }
            return this.data.length;
        },
        selectionCounter(){
            let data = [];
            this.selectedTargets.map(item => {
                item.data.map(x => {
                    if(x.toggleSelected){
                        data.push(x.id);
                    }
                })
            })
            return data;
        },
        filteredTargets(){
            let data = this.selectedTargets;
            if (this.searchTargetApi.trim() != "" && this.searchTargetApi) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.searchTargetApi.toUpperCase());
                });
            }
            return data;
        }
    },
    methods: {
        onFiltered(data) {
            this.totalRows = data.length;
            this.currentPage = 1;
        },
        showTargets(du){
            this.selectedDU = du;
            this.selectedTargets = [];
            let group = groupBy(du.data, "planningTargetId");
            for (const key in group) {
                let searchKey = group[key][0].planningTarget.description + ' ' + group[key][0].planningTarget.planningMainTarget.indicatorItem.indicatorItemName;
                group[key].forEach((item) => {
                    searchKey += ` ${item.name}`;
                    item.searchKey = group[key][0].planningTarget.description + ' ' + group[key][0].planningTarget.planningMainTarget.indicatorItem.indicatorItemName + ' ' + item.name;
                });
                this.selectedTargets.push({
                    data: group[key],
                    name: group[key][0].planningTarget.description,
                    points: group[key][0].planningTarget.points,
                    q1: group[key][0].planningTarget.q1,
                    q2: group[key][0].planningTarget.q2,
                    q3: group[key][0].planningTarget.q3,
                    q4: group[key][0].planningTarget.q4,
                    indicatorItemName: group[key][0].planningTarget.planningMainTarget.indicatorItem.indicatorItemName,
                    showApis: this.forApproval,
                    selectAllApis: false,
                    searchKey: searchKey
                })
               
            }
        },
        viewApis(target){
            target.showApis = !target.showApis;
        },
        async viewDetails(row){
            row.showDetails = !row.showDetails;
            if(row.showDetails){
                row.loadingResources = true;
                await this.getApiResources(row);
                row.loadingResources = false;
            }
        },
        async getApiResources(row){
            await this.$store
                .dispatch(
                    "planningapiresource/GetPlanningApiResourcesByApi",
                    row.id
                )
                .then((res) => {
                    if(res.data.error){
                        row.loadingResources = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.q1 = 0;
                        item.q2 = 0;
                        item.q3 = 0;
                        item.q4 = 0;
                        item.planningApiResourceDetails.map((x) => {
                            if (x.monthId == 1 || x.monthId == 2 || x.monthId == 3) {
                                item.q1 += x.quantity;
                            } else if (x.monthId == 4 || x.monthId == 5 || x.monthId == 6) {
                                item.q2 += x.quantity;
                            } else if (x.monthId == 7 || x.monthId == 8 || x.monthId == 9) {
                                item.q3 += x.quantity;
                            } else if (x.monthId == 10 || x.monthId == 11 || x.monthId == 12) {
                                item.q4 += x.quantity;
                            }
                        });
                    })
                    row.apiResources = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        selectTarget(target){
            target.data.map(item => {
                item.toggleSelected = target.selectAllApis;
                console.log(item)
            })
        },
        selectApi(target){
            target.selectAllApis = target.data.every((item) => item.toggleSelected);
        },
        filteredApi(data){
            if (this.searchTargetApi.trim() != "" && this.searchTargetApi) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.searchTargetApi.toUpperCase());
                });
            }
            return data;
        },
        approveApis(){
            this.$emit('approve-apis', {ids: this.selectionCounter, deliveryUnit: this.selectedDU});
        },
        returnApi(api){
            this.$emit('return-api', {id: api.id, deliveryUnit: this.selectedDU});
        },
    }
}
</script>
<template>
    <div>
        <div class="card border" >
            <div class="card-body" v-if="!selectedDU">
                <div class="row mt-2 mb-2">
                    <div class="col-sm-12 col-md-6">
                        <h4 class="card-title m-0">
                            {{ title }}
                        </h4>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="
                                dataTables_filter
                                text-md-end
                            "
                        >
                            <label
                                class="
                                    d-inline-flex
                                    align-items-center
                                "
                            >
                                Search:
                                <b-form-input
                                    autocomplete="off"
                                    v-model="filter"
                                    type="search"
                                    placeholder="Search DU..."
                                    class="
                                        form-control
                                        form-control-sm
                                        ms-2
                                    "
                                ></b-form-input>
                                <b-form-select
                                    class="
                                        form-select
                                        form-select-sm
                                        w-100p
                                        ms-1
                                    "
                                    v-model="perPage"
                                    size="sm"
                                    :options="pageOptions"
                                ></b-form-select>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>
                <div class="text-center mt-2" v-if="!busy && data.length == 0">
                    <h4>No data found</h4>
                </div>
                <div class="text-center mt-2" v-if="!busy && data.length > 0 && filtered.length == 0">
                    <h4>Search not found</h4>
                </div>
                <div
                    class="
                        d-flex
                        justify-content-center
                        align-items-center
                    "
                    v-if="busy"
                >
                    <div class="preloader-component me-2">
                        <div class="status">
                            <div class="spinner-chase w-20px h-20px">
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                            </div>
                        </div>
                    </div>
                    <strong>Loading...</strong>
                </div>
                <div v-if="!busy && filtered.length > 0">
                    <div role="tablist" v-for="y in filtered" :key="y.id">
                        <div class="card mb-2">
                            <div class="card-header" role="tab">
                                <div class="d-flex align-items-center justify-content-between cursor-pointer" @click="showTargets(y)">
                                    <h4 class="mb-0 text-info">
                                        {{y.name}}
                                    </h4>
                                    <div class="d-flex align-items-center">
                                        <span>Show Targets</span>
                                        <i
                                            class="
                                                bx bx-chevron-right
                                                font-size-18
                                                me-2
                                            "
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <div
                                class="
                                    dataTables_paginate
                                    paging_simple_numbers
                                    float-end
                                "
                            >
                                <ul
                                    class="
                                        pagination
                                        pagination-rounded
                                        mb-0
                                    "
                                >
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="rows"
                                        :per-page="perPage"
                                    ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body" v-if="selectedDU">
                <div class="row my-2">
                    <div class="col-sm-12 col-md-4">
                        <h4 class="card-title mb-3 d-flex align-items-center"><a href="javascript:void(0);" @click="selectedDU = null;" class="font-size-20 font-weight-bold me-2"><i class="bx bx-arrow-back"></i></a>{{selectedDU.name}}'s target(s)</h4>
                    </div>
                    <div class="col-sm-12 col-md-8">
                        <div
                            id="tickets-table_filter"
                            class="
                                dataTables_filter
                                text-md-end
                            "
                        >
                            <label
                                class="
                                    d-inline-flex
                                    align-items-center
                                    mb-0
                                "
                            >
                                <b-form-input
                                    autocomplete="off"
                                    v-model="searchTargetApi"
                                    type="search"
                                    placeholder="Search API/Target..."
                                    class="
                                        form-control
                                        form-control-sm
                                        mx-2
                                    "
                                ></b-form-input>
                                <div v-if="selectionCounter.length && forApproval">
                                    <button type="button" class="btn btn-sm btn-success no-wrap" @click="approveApis"><i class="bx bx-check"></i> Approve selected API</button>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <div
                    role="tablist"
                    v-for="(w, wIndex) in filteredTargets"
                    :key="w.id"
                >
                    <b-card
                        no-body
                        class="mb-2 shadow-none"
                        :style="{ 'z-index': filteredTargets.length - wIndex }"
                    >
                        <b-card-header
                            header-tag="header"
                            role="tab"
                            header-class="cursor-pointer border"
                        >
                            <div
                                class="d-flex justify-content-between align-items-center"
                                @click="viewApis(w)"
                            >
                                <div class="d-flex align-items-center">
                                    <div
                                        class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                        style="min-width: 30px"
                                    >
                                        <h3 class="mb-0 position-relative">
                                            {{ wIndex + 1 }}
                                        </h3>
                                    </div>
                                    <div>
                                        <h6 class="mb-0">
                                            <a
                                            class="text-dark"
                                            href="javascript: void(0);"
                                            >{{ w.name }}</a
                                            >
                                        </h6>
                                        <small class="text-pink">{{
                                            w.indicatorItemName
                                        }}</small>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span class="d-flex align-items-center">
                                            <small v-if="!w.showApis">Click here to expand</small>
                                            <div v-else>
                                                <table class="table table-bordered mb-0">
                                                    <tr>
                                                        <th rowspan="2" class="text-center" style="width:100px;">Targets</th>
                                                        <th class="text-center" style="width:50px;">Q1</th>
                                                        <th class="text-center" style="width:50px;">Q2</th>
                                                        <th class="text-center" style="width:50px;">Q3</th>
                                                        <th class="text-center" style="width:50px;">Q4</th>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center text-green font-weight-bold">{{w.q1}}</td>
                                                        <td class="text-center text-green font-weight-bold">{{w.q2}}</td>
                                                        <td class="text-center text-green font-weight-bold">{{w.q3}}</td>
                                                        <td class="text-center text-green font-weight-bold">{{w.q4}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <i 
                                                    class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                    :class="{'rotate-90': w.showApis}"
                                                ></i>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </b-card-header>
                        <b-collapse
                          :visible="w.showApis"
                          :accordion="`submitted-accordion-${w.id}`"
                          role="tabpanel"
                        >
                            <b-card-body class="border px-2 py-2">
                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <div class="ms-2">
                                        &#62;&#62; List of APIs &#60;&#60;
                                    </div>
                                    <div class="d-flex" v-if="forApproval && w.showApis">
                                        <div
                                            class="
                                                form-check
                                                form-checkbox-outline
                                                form-check-success
                                                mb-0
                                            "
                                        >
                                            <input
                                                type="checkbox"
                                                :id="`targetID-${w.id}`"
                                                class="form-check-input"
                                                v-model="w.selectAllApis"
                                                @change="selectTarget(w)"
                                            />
                                            <label
                                                :for="`targetID-${w.id}`"
                                                class="form-check-label"
                                            >
                                                Check All Api(s)
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div v-for="y in filteredApi(w.data)" :key="y.id">
                                    <div class="d-flex align-items-center justify-content-between border-top border-bottom p-2" >
                                        <div>
                                            <div class="d-flex" v-if="forApproval">
                                                <div
                                                    class="
                                                        form-check
                                                        form-checkbox-outline
                                                        form-check-success
                                                        mb-0
                                                    "
                                                >
                                                    <input
                                                        type="checkbox"
                                                        :id="`apiID-${y.id}`"
                                                        class="form-check-input"
                                                        v-model="y.toggleSelected"
                                                        @change="selectApi(w)"
                                                    />
                                                    <label
                                                        :for="`apiID-${y.id}`"
                                                        class="form-check-label"
                                                    >
                                                        <h5 class="mb-0 text-info">{{y.name}}</h5>
                                                    </label>
                                                </div>
                                            </div>
                                            <h5 class="mb-0 text-info" v-else>{{y.name}}</h5>
                                            <div>
                                                Total: {{formatCurrency(y.total)}} <span v-if="forApproval">| <a href="javascript:void(0);" class="text-warning " @click="returnApi(y)"><i class="bx bx-chevrons-left"></i> Return API</a></span>
                                            </div>
                                        </div>
                                        <a href="javascript:void(0);" @click="viewDetails(y)" class="text-green me-2">{{y.showDetails ? 'Hide' : 'View'}} Details</a>
                                    </div>
                                    <b-collapse
                                        :visible="y.showDetails"
                                        :accordion="`submitted-accordion-${y.id}`"
                                        role="tabpanel"
                                    >
                                        <table
                                            class="
                                                table
                                                table-bordered
                                                border-secondary
                                            "
                                        >
                                            <tr>
                                                <th
                                                    rowspan="2"
                                                    class="
                                                        text-left
                                                        px-2
                                                    "
                                                >
                                                    Item
                                                    Name
                                                </th>
                                                <th
                                                    colspan="4"
                                                    class="
                                                        text-center
                                                    "
                                                    style="
                                                        width: 400px;
                                                    "
                                                >
                                                    Quantity
                                                </th>
                                                <th
                                                    rowspan="2"
                                                    class="
                                                        text-center
                                                    "
                                                    style="
                                                        width: 150px;
                                                    "
                                                >
                                                    Unit
                                                    Cost
                                                </th>
                                                <th
                                                    rowspan="2"
                                                    class="
                                                        text-center
                                                    "
                                                    style="
                                                        width: 150px;
                                                    "
                                                >
                                                    Total
                                                </th>
                                            </tr>
                                            <tr>
                                                <th
                                                    class="
                                                        text-center
                                                    "
                                                    style="
                                                        width: 100px;
                                                    "
                                                >
                                                    Quarter
                                                    1
                                                </th>
                                                <th
                                                    class="
                                                        text-center
                                                    "
                                                    style="
                                                        width: 100px;
                                                    "
                                                >
                                                    Quarter
                                                    2
                                                </th>
                                                <th
                                                    class="
                                                        text-center
                                                    "
                                                    style="
                                                        width: 100px;
                                                    "
                                                >
                                                    Quarter
                                                    3
                                                </th>
                                                <th
                                                    class="
                                                        text-center
                                                    "
                                                    style="
                                                        width: 100px;
                                                    "
                                                >
                                                    Quarter
                                                    4
                                                </th>
                                            </tr>
                                            <template v-if="y.loadingResources">
                                                <tr>
                                                    <td colspan="100%" class="text-center">
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-center
                                                                align-items-center
                                                            "
                                                        >
                                                            <div
                                                                class="
                                                                    preloader-component
                                                                    me-2
                                                                "
                                                            >
                                                                <div class="status">
                                                                    <div
                                                                        class="
                                                                            spinner-chase
                                                                            w-20px
                                                                            h-20px
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <strong>Loading...</strong>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                            <tr
                                                v-for="x in y.apiResources"
                                                :key="x.id"
                                            >
                                                <td>
                                                    <div
                                                        class="
                                                            mb-0
                                                        "
                                                    >
                                                        <div>
                                                            {{
                                                                x.itemName
                                                            }}
                                                        </div>
                                                        <small
                                                            >{{
                                                                x.description
                                                            }}</small
                                                        >
                                                    </div>
                                                </td>
                                                <td
                                                    class="
                                                        text-center
                                                    "
                                                >
                                                    {{
                                                        x.q1
                                                    }}
                                                </td>
                                                <td
                                                    class="
                                                        text-center
                                                    "
                                                >
                                                    {{
                                                        x.q2
                                                    }}
                                                </td>
                                                <td
                                                    class="
                                                        text-center
                                                    "
                                                >
                                                    {{
                                                        x.q3
                                                    }}
                                                </td>
                                                <td
                                                    class="
                                                        text-center
                                                    "
                                                >
                                                    {{
                                                        x.q4
                                                    }}
                                                </td>
                                                <td
                                                    class="
                                                        text-center
                                                    "
                                                >
                                                    {{
                                                        formatCurrency(
                                                            x.unitCost
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    class="
                                                        text-center
                                                    "
                                                >
                                                    {{
                                                        formatCurrency(
                                                            x.total
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                            </template>
                                        </table>
                                    </b-collapse>
                                </div>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>